/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable unused-imports/no-unused-imports */
import { useEffect, useMemo, useRef, useState } from "react";
import PulseLoader from "react-spinners/PulseLoader";
import { FormGroup, FormControl, Row, Col, Button, Form } from "react-bootstrap";
import { debounce } from "lodash";
import axios from "axios";
import { toast } from "react-toastify";

import CreateNewClientHeader from "../CreateClientHeader";
import "./NewClient.css";
import {
  formatCalendarDateForInput,
  formatPhoneNumber,
  getFieldClass,
  insuranceStyles,
} from "../../../Utils/helper";
import SelectStateModal from "../../TreatmentPage/modals/state-modal/SelectStateModal";
import { api_without_cancellation } from "../../../api/api";
import AutoCompleteSearch from "../../Insurance/AutoCompleteSearch";
import DateInput from "../../common/DateInput";
// import ContactPanelForTreatment from "../../TreatmentPage/components/ContactPanelForTreatment";
import ContactPanelForEditPopups from "../../TreatmentPage/components/ContactPanelForEditPopups";

import SourceLinking from "./source-linking";
import useSourceSearch from "./hooks/useSourceSearch";

const NewClient = ({
  data,
  onChange,
  // isEmailValid,
  setEmailValid,
  // isPhoneValid,
  setPhoneValid,
  loading,
  setLoading,
  fieldStates,
  sourceTypes,
  sourceCategories,
  caseSources,
  caseTypes,
  insuranceTypes,
  insuranceNewTypes,
  defendantTypes,
  reportingagencyTypes,
  state,
  _homeStateIntake,
  setHomeStateIntake,
  homeStateClient,
  setHomeStateClient,
  homeStateDefendant,
  setHomeStateDefendant,
  _homeStateSource,
  setHomeStateSource,
  pendingLeadData,
  pendingLeadAvailable,
  storedLeadData,
  subActiveTab,
  setStoreLink,
  loadingSave,
  setLoadingSave,
  setShowPopup,
  setShowNormal,
}) => {
  const [activeTab, setActiveTab] = useState("client");
  const [clientNameValidationAttempted, setClientNameValidationAttempted] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSourceName, setSelectedSourceName] = useState("");
  const [disabledCategory, setDisabledCategory] = useState(true);
  const [disabledSourceName, setDisabledSourceName] = useState(true);
  const _selectedOptionCase = null;

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  // const phoneRegex = /^(?:\d{10}|\(\d{3}\) \d{3}-\d{4})$/;
  const [filteredCaseTypes, setFilteredCaseTypes] = useState([]); //
  const [selectedCaseCategory, setSelectedCaseCategory] = useState(1);
  const [homeStateVenue, setHomeStateVenue] = useState(null);
  const [showStatesModalIntake, setShowStatesModalIntake] = useState(false);
  const [showStatesModalClient, setShowStatesModalClient] = useState(false);
  const [showStatesModalDefendant, setShowStatesModalDefendant] = useState(false);
  const [showStatesModalSource, setShowStatesModalSource] = useState(false);
  const [showStatesModalVenue, setShowStateModalVenue] = useState(false);
  const InsuranceButtons = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: () => {},
    },
  ];
  useEffect(() => {
    if (data?.client_case_category) {
      setSelectedCaseCategory(data.client_case_category);

      const category = caseTypes?.find((cat) => cat.id === data.client_case_category);
      setFilteredCaseTypes(category ? category.case_types : []);
    }
    // if (data?.source_type) {
    //   setSelectedType(data.source_type);
    // }
    // if (data?.source_category) {
    //   setSelectedCategory(data.source_category);
    // }
    // if (data?.source_name) {
    //   setSelectedSourceName(data.source_name);
    // }
  }, [data, caseTypes]);

  // Handle email input change
  const handleClientEmailChange = (e) => {
    const email = e.target.value;
    onChange("client_email", email);

    if (email !== "") {
      setEmailValid((prevValid) => ({
        ...prevValid,
        client_email: emailRegex.test(email),
      }));
    } else {
      setEmailValid((prevValid) => ({
        ...prevValid,
        client_email: true, // Set as valid when empty
      }));
    }
  };

  // Handle defendant email input change
  const handleDefendantEmailChange = (e) => {
    const email = e.target.value;
    onChange("defendant_email", email);

    if (email !== "") {
      setEmailValid((prevValid) => ({
        ...prevValid,
        defendant_email: emailRegex.test(email),
      }));
    } else {
      setEmailValid((prevValid) => ({
        ...prevValid,
        defendant_email: true, // Set as valid when empty
      }));
    }
  };

  const handleClientPhoneChange = (e) => {
    const phone = e.target.value.replace(/\D/g, "");
    let formattedValue = "";
    if (phone.length > 0) {
      formattedValue += `(${phone.slice(0, 3)}`;
    }
    if (phone.length > 3) {
      formattedValue += `) ${phone.slice(3, 6)}`;
    }
    if (phone.length > 6) {
      formattedValue += `-${phone.slice(6, 10)}`;
    }

    e.target.value = formattedValue;
    onChange("client_phone", formattedValue);

    if (phone !== "") {
      setPhoneValid((prevValid) => ({
        ...prevValid,
        client_phone: true,
      }));
    } else {
      setPhoneValid((prevValid) => ({
        ...prevValid,
        client_phone: true, // Set as valid when empty
      }));
    }
  };

  const handleDefendantPhoneChange = (e) => {
    const phone = e.target.value.replace(/\D/g, "");
    let formattedValue = "";
    if (phone.length > 0) {
      formattedValue += `(${phone.slice(0, 3)}`;
    }
    if (phone.length > 3) {
      formattedValue += `) ${phone.slice(3, 6)}`;
    }
    if (phone.length > 6) {
      formattedValue += `-${phone.slice(6, 10)}`;
    }

    e.target.value = formattedValue;
    onChange("defendant_phone", formattedValue);

    if (phone !== "") {
      setPhoneValid((prevValid) => ({
        ...prevValid,
        defendant_phone: true,
      }));
    } else {
      setPhoneValid((prevValid) => ({
        ...prevValid,
        defendant_phone: true, // Set as valid when empty
      }));
    }
  };
  // Handler for category change
  const handleCaseCategoryChange = (value) => {
    const categoryId = parseInt(value, 10);
    setSelectedCaseCategory(categoryId);
    const category = caseTypes?.find((cat) => cat.id === categoryId);
    setFilteredCaseTypes(category ? category.case_types : []); // Update filtered types
    onChange("client_case_category", categoryId);
    onChange("client_case_type", 0);
    if (categoryId === 0) {
      onChange("client_case_type", 0);
    }
  };

  const handleTypeChange = (e) => {
    const selectedTypeValue = parseInt(e.target.value, 10); // Ensure it's an integer
    setSelectedType(selectedTypeValue);
    setSelectedCategory("");
    setSelectedSourceName("");
    setDisabledCategory(selectedTypeValue === 0);
    setDisabledSourceName(true);
    onChange("source_type", selectedTypeValue);

    if (selectedTypeValue === 0) {
      onChange("source_category", 0);
      onChange("source_name", 0);
    }
  };

  const handleCategoryChange = (e) => {
    const selectedCategoryValue = parseInt(e.target.value, 10);
    setSelectedCategory(selectedCategoryValue);
    setSelectedSourceName("");
    setDisabledSourceName(selectedCategoryValue === 0);
    onChange("source_category", selectedCategoryValue);

    if (selectedCategoryValue === 0) {
      onChange("source_name", 0);
    }
  };

  const handleSourceNameChange = (e) => {
    setSelectedSourceName(parseInt(e.target.value, 10));

    const selectedCategoryValue = parseInt(e.target.value, 10);
    onChange("source_name", selectedCategoryValue);
  };

  // Filter source categories based on selected type
  const filteredCategories = sourceCategories.filter(
    (category) => category.source_type === selectedType
  );

  // Filter case sources based on selected type and category
  const filteredCaseSources = caseSources.filter(
    (source) => source.source_type === selectedType && source.source_category === selectedCategory
  );

  // const tooltip = <Tooltip id="tooltip">Please enter an valid email address</Tooltip>;

  // const tooltipphone = <Tooltip id="tooltip">Phone number must be of 10 digits</Tooltip>;

  // For venue
  const [selectedState, setSelectedState] = useState("");
  const [filteredVenue, setFilteredVenue] = useState([]);
  const handleCaseState = (value) => {
    const stateName = value;
    // setSelectedState(stateName);
    // const venue = state?.find((stat) => stat.StateAbr === stateName);
    // setFilteredVenue(venue ? venue.counties : []);
    onChange("client_state", stateName);

    // if (stateName === "") {
    //   onChange("intake_venue_county", "");
    // }
  };

  const handleCaseState2 = (value) => {
    const stateName = value;
    setSelectedState(stateName);
    const venue = state?.find((stat) => stat.StateAbr === stateName);
    setFilteredVenue(venue ? venue.counties : []); // Update filtered types
    // onChange("client_state", stateName);

    // if (stateName === "") {
    //   onChange("intake_venue_county", "");
    // }
  };

  // const sidebarItems = [
  //   { id: "client", name: "Client" },
  //   { id: "defendant", name: "Defendant" },
  //   { id: "source", name: "Source" },
  //   { id: "Notes", name: "Notes" },
  // ];

  const handleTabChange = (id) => {
    setActiveTab(id);
  };

  const sidebarItems = useMemo(() => {
    const tabs = [];
    //

    tabs.push({
      id: "client",
      label: "Client",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handleTabChange("client"),
      leftHand: false,
    });

    tabs.push({
      id: "defendant",
      label: "Defendant",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handleTabChange("defendant"),
      leftHand: false,
    });

    tabs.push({
      id: "Reports",
      label: "Reports",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handleTabChange("Reports"),
      leftHand: false,
    });

    tabs.push({
      id: "source",
      label: "Source",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handleTabChange("source"),
      leftHand: false,
    });

    tabs.push({
      id: "Notes",
      label: "Notes",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handleTabChange("Notes"),
      leftHand: false,
    });

    return tabs;
  }, []);

  // const onChange2 = (field, value) => {
  //   setData((prev) => ({ ...prev, [field]: value }));
  // };

  // const handleSourceSelect = (sourceKey, sourceId) => {
  //   if (sourceId) {
  //     // Find the selected source
  //     const _selectedSource = mockCaseSources.find((s) => s.id === sourceId);
  //     setCurrentSourceKey(sourceKey);
  //     setShowDetailsModal(true);
  //   }
  // };

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [defendantTypeId, setDefendantTypeId] = useState(1);
  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [insuranceTypeOpen, setInsuranceTypeOpen] = useState(false);
  const [insuranceCompanyOpen, setInsuranceCompanyOpen] = useState(false);
  const [defInsuranceTypeOpen, setDefInsuranceTypeOpen] = useState(false);
  const [defInsuranceCompanyOpen, setDefInsuranceCompanyOpen] = useState(false);
  const [defendantTypeOpen, setDefendantTypeOpen] = useState(false);
  const [reportingAgencyOpen, setReportingAgencyOpen] = useState(false);
  const [sourceNameOpen, setSourceNameOpen] = useState(false);
  const [sourceCategoryOpen, setSourceCategoryOpen] = useState(false);
  const [sourceTypeOpen, setSourceTypeOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [linkedSources, setLinkedSources] = useState([]);
  const sourceLinkingRef = useRef(null);
  const { results: searchedSources, isLoading: sourceSearchLoading } = useSourceSearch(search);
  const [pendingSourceStateKey, setPendingSourceStateKey] = useState(null);
  const [linkModal, setLinkModal] = useState(false);
  const handleSave = async () => {
    const storedLeadDataNew = JSON.parse(localStorage.getItem("LeadData"));
    const missingFirstName = !data.client_first_name?.trim();
    const missingLastName = !data.client_last_name?.trim();

    if (missingFirstName || missingLastName) {
      setClientNameValidationAttempted(true);
      setActiveTab("client");
      toast.error(
        missingFirstName && missingLastName
          ? "Client first name and last name are required"
          : missingFirstName
            ? "Client first name is required"
            : "Client last name is required"
      );
      return;
    }

    if (!data.client_case_type || data.client_case_type === 0) {
      toast.error("Please select a case type before saving");
      return;
    }
    // const dataToSave = formData[tabKey];
    const dataToSave = {
      ...data,
      defendant_dob: formatCalendarDateForInput(data.defendant_dob) || null,
      case_sources: [...linkedSources],
      ...(storedLeadDataNew &&
      subActiveTab === storedLeadDataNew.LeadActiveTab &&
      pendingLeadAvailable
        ? { lead_id: pendingLeadData.id }
        : { lead_id: null }),
    };

    if (dataToSave.client_id === 0 || dataToSave.client_id === undefined) {
      delete dataToSave.client_id;
    }
    if (dataToSave.case_id === 0) {
      delete dataToSave.case_id;
    }

    const filteredData = Object.fromEntries(
      Object.entries(dataToSave).filter(([key]) => {
        const fieldMappings = {
          jurisdiction: ["intake_jurisdiction"],
          venue_county: ["intake_venue_county"],
        };

        for (const [fieldKey, formFields] of Object.entries(fieldMappings)) {
          if (formFields.includes(key)) {
            return fieldStates[fieldKey] !== false; // Include if enabled in fieldStates
          }
        }

        // Include all other fields by default
        return true;
      })
    );
    try {
      setLoadingSave(true);

      const response = await api_without_cancellation.post(
        "/api/new_client_new_case_with_sources/",
        filteredData
      );
      if (response.status === 200 || response.status === 201) {
        const result = await response.data;
        if (storedLeadData && subActiveTab === storedLeadData.LeadActiveTab) {
          localStorage.removeItem("LeadData");
        }
        setLinkedSources([]);
        setStoreLink(result);
        setLoadingSave(false);
        setShowPopup(true);
        setShowNormal(false);
      } else {
        console.error("Failed to save data:", response.statusText);
        setLoadingSave(false);
        if (response?.status === 402) {
          toast.error("Free accounts cannot add new clients");
          return;
        } else {
          toast.error("Failed to save the data");
        }
      }
    } catch (error) {
      console.error("Error during save operation:", error);
    } finally {
      setLoadingSave(false);
    }
  };
  let search_input = "";
  const [searchedInsurances, setSerachInsurances] = useState([]);
  const [searchedAjusters, setSerachAdjusters] = useState([]);
  const [searchedInsurancesDef, setSerachInsurancesDef] = useState([]);
  const [searchedAjustersDef, setSerachAdjustersDef] = useState([]);
  const [searchReportDef, setSearchReportDef] = useState([]);

  const origin = process.env.REACT_APP_BACKEND_URL || "https://dev.simplefirm.com";

  const fetchData = async (search, type) => {
    try {
      const params = { query: search };
      let response;

      if (type === "company") {
        response = await api_without_cancellation.get("/api/insurances/search/", { params });
      } else if (type === "adjuster") {
        response = await api_without_cancellation.get(
          "api/general/search_filter_adjuster_directoires/",
          {
            params,
          }
        );
      }

      const data = response.data.data; // no frontend filtering

      if (type === "company") {
        setSerachInsurances(data);
        setSerachAdjusters([]);
      }
      if (type === "adjuster") {
        setSerachAdjusters(data);
        setSerachInsurances([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const debouncedFetch = useMemo(
    () => debounce((search, type) => fetchData(search, type), 400),
    []
  );

  const fetchDataDef = async (search, type) => {
    try {
      const params = { query: search };
      let response;

      if (type === "company") {
        response = await api_without_cancellation.get("/api/insurances/search/", { params });
      } else if (type === "adjuster") {
        response = await api_without_cancellation.get(
          "/api/general/search_filter_adjuster_directoires/",
          {
            params,
          }
        );
      } else if (type === "reporting") {
        response = await api_without_cancellation.get("/api/reporting_agency_search/", {
          params,
        });
      }

      const data = response.data.data; // no frontend filtering
      if (type === "company") {
        setSerachInsurancesDef(data);
        setSerachAdjustersDef([]);
        setSearchReportDef([]);
      }
      if (type === "adjuster") {
        setSerachAdjustersDef(data);
        setSerachInsurancesDef([]);
      }
      if (type === "reporting") {
        setSearchReportDef(data);
        setSerachAdjustersDef([]);
        setSerachInsurancesDef([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const debouncedFetchDef = useMemo(
    () => debounce((search, type) => fetchDataDef(search, type), 400),
    []
  );

  const [companySearchInput, setCompanySearchInput] = useState("");
  const [adjusterSearchInput, setAdjusterSearchInput] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedAdjuster, setSelectedAdjuster] = useState(null);

  const handleSearchInsurances = (event, type) => {
    search_input = event.target.value;
    if (search_input === "") {
      setSerachInsurancesDef([]);
      setSerachAdjustersDef([]);
      setSearchReportDef([]);
    } else if (search_input.length >= 2) {
      debouncedFetch(search_input, type);
    } else {
      setSerachInsurances([]);
      setSerachAdjusters([]);
    }
  };

  const handleSelectedInsuranceTabs = (type, id) => {
    if (type === "company") {
      const a = searchedInsurances?.find((a) => a?.id === id);
      setSelectedCompany(a);
      onChange("client_insurance_company_id", a?.company_id);
      setCompanySearchInput(a?.company_name || "");
      onChange("client_company_name", a.company_name);
      onChange("client_company_address1", a.address1);
      onChange("client_company_address2", a.address2);
      onChange("client_company_city", a.city);
      onChange("client_company_state", a.state);
      onChange("client_company_zip", a.zip);
      onChange("client_company_phone", formatPhoneNumber(a.phone));
      onChange("client_company_extension_field", a?.extension || "");
      onChange("client_company_fax", formatPhoneNumber(a.fax));
      onChange("client_company_email", a.email);
      onChange("client_company_website", a.website);
    }
    if (type === "adjuster") {
      onChange("client_insurance_adjuster_id", id);
      const a = searchedAjusters?.find((a) => a?.id === id);
      setSelectedAdjuster(a);
      const name = `${a?.first_name} ${a?.last_name}`;
      setAdjusterSearchInput(name || "");
      onChange("client_adjuster_first_name", a.first_name);
      onChange("client_adjuster_last_name", a.last_name);
      onChange("client_adjuster_address1", a.address1);
      onChange("client_adjuster_address2", a.address2);
      onChange("client_adjuster_city", a.city);
      onChange("client_adjuster_state", a.state);
      onChange("client_adjuster_zip", a.zip);
      onChange("client_adjuster_phone", formatPhoneNumber(a.phone));
      onChange("client_adjuster_extension_field", a?.extension || "");
      onChange("client_adjuster_fax", formatPhoneNumber(a.fax));
      onChange("client_adjuster_email", a.email);
      onChange("client_adjuster_website", a.website);
    }
    setSerachAdjusters([]);
    setSerachInsurances([]);
  };
  const [companySearchInputDef, setCompanySearchInputDef] = useState("");
  const [adjusterSearchInputDef, setAdjusterSearchInputDef] = useState("");
  const [selectedCompanyDef, setSelectedCompanyDef] = useState(null);
  const [selectedAdjusterDef, setSelectedAdjusterDef] = useState(null);
  const [reportSearchInputDef, setReportSearchInputDef] = useState("");

  let search_input_def = "";
  const handleSearchInsurancesDef = (event, type) => {
    search_input_def = event.target.value;
    if (search_input_def === "") {
      setSerachInsurancesDef([]);
      setSerachAdjustersDef([]);
      setSearchReportDef([]);
    } else if (search_input_def.length >= 2) {
      debouncedFetchDef(search_input_def, type);
    } else {
      setSerachInsurancesDef([]);
      setSerachAdjustersDef([]);
      setSearchReportDef([]);
    }
  };

  const handleSelectedInsuranceTabsDef = (type, id) => {
    if (type === "company") {
      const a = searchedInsurancesDef?.find((a) => a?.id === id);
      setSelectedCompanyDef(a);
      onChange("defendant_company_id", a?.company_id);

      setCompanySearchInputDef(a?.company_name || "");
      onChange("defendant_company_name", a.company_name);
      onChange("defendant_company_address1", a.address1);
      onChange("defendant_company_address2", a.address2);
      onChange("defendant_company_city", a.city);
      onChange("defendant_company_state", a.state);
      onChange("defendant_company_zip", a.zip);
      onChange("defendant_company_phone", formatPhoneNumber(a.phone));
      onChange("defendant_company_extension_field", a?.extension || "");
      onChange("defendant_company_fax", formatPhoneNumber(a.fax));
      onChange("defendant_company_email", a.email);
      onChange("defendant_company_website", a.website);
    }
    if (type === "adjuster") {
      onChange("defendant_adjuster_id", id);
      const a = searchedAjustersDef?.find((a) => a?.id === id);
      setSelectedAdjusterDef(a);
      const name = `${a?.first_name} ${a?.last_name}`;
      setAdjusterSearchInputDef(name || "");
      onChange("defendant_adjuster_first_name", a.first_name);
      onChange("defendant_adjuster_last_name", a.last_name);
      onChange("defendant_adjuster_address1", a.address1);
      onChange("defendant_adjuster_address2", a.address2);
      onChange("defendant_adjuster_city", a.city);
      onChange("defendant_adjuster_state", a.state);
      onChange("defendant_adjuster_zip", a.zip);
      onChange("defendant_adjuster_phone", formatPhoneNumber(a.phone));
      onChange("defendant_adjuster_extension_field", a?.extension || "");
      onChange("defendant_adjuster_fax", formatPhoneNumber(a.fax));
      onChange("defendant_adjuster_email", a.email);
      onChange("defendant_adjuster_website", a.website);
    }
    if (type === "reporting") {
      onChange("defendant_reporting_agency", id);
      // setReportSearchInputDef(id || "");
      const a = searchReportDef?.find((a) => a?.id === id);
      setReportSearchInputDef(a?.reporting_agency || "");
      onChange("defendant_report_name", a.reporting_agency);
      onChange("defendant_report_address1", a?.contact_id.address1);
      onChange("defendant_report_address2", a?.contact_id.address2);
      onChange("defendant_report_city", a?.contact_id.city);
      onChange("defendant_report_state", a?.contact_id.state);
      onChange("defendant_report_zip", a?.contact_id.zip);
      onChange("defendant_report_phone", formatPhoneNumber(a?.contact_id.phone));
      onChange("defendant_report_extension_field", a?.contact_id.extension || "");
      onChange("defendant_report_fax", formatPhoneNumber(a?.contact_id.fax));
      onChange("defendant_report_email", a?.contact_id.email);
      onChange("defendant_report_website", a?.contact_id.website);
    }
    setSerachAdjustersDef([]);
    setSerachInsurancesDef([]);
    setSearchReportDef([]);
  };

  const [insuranceNewCompanyState, setInsuranceNewCompanyState] = useState(false);
  const handleStateShow = () => setInsuranceNewCompanyState(!insuranceNewCompanyState);

  const [adjusterState, setAdjusterState] = useState(false);
  const handleAdjusterStateShow = () => setAdjusterState(!adjusterState);

  const [insuranceNewCompanyStateDef, setInsuranceNewCompanyStateDef] = useState(false);
  const handleStateShowDef = () => setInsuranceNewCompanyStateDef(!insuranceNewCompanyStateDef);

  const [adjusterStateDef, setAdjusterStateDef] = useState(false);
  const handleAdjusterStateShowDef = () => setAdjusterStateDef(!adjusterStateDef);
  const [reportState, setReportState] = useState(false);
  const handleStateShowRep = () => setReportState(!reportState);
  const insuranceTypeRef = useRef(null);
  const companySearchRef = useRef(null);
  const adjusterSearchRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (insuranceTypeRef.current && !insuranceTypeRef.current.contains(e.target)) {
        setInsuranceTypeOpen(false);
      }
      if (companySearchRef.current && !companySearchRef.current.contains(e.target)) {
        setSerachInsurances([]);
      }
      if (adjusterSearchRef.current && !adjusterSearchRef.current.contains(e.target)) {
        setSerachAdjusters([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const defInsuranceTypeRef = useRef(null);
  const defCompanySearchRef = useRef(null);
  const defAdjusterSearchRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (defInsuranceTypeRef.current && !defInsuranceTypeRef.current.contains(e.target)) {
        setDefInsuranceTypeOpen(false);
      }
      if (defCompanySearchRef.current && !defCompanySearchRef.current.contains(e.target)) {
        setSerachInsurancesDef([]);
      }
      if (defAdjusterSearchRef.current && !defAdjusterSearchRef.current.contains(e.target)) {
        setSerachAdjustersDef([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const defReportSearchRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (defReportSearchRef.current && !defReportSearchRef.current.contains(e.target)) {
        setSearchReportDef([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handlePhoneChange = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    let formattedValue = numbers;

    if (numbers.length > 3) {
      formattedValue = `(${numbers.slice(0, 3)})`;
      if (numbers.length > 3) {
        formattedValue += ` ${numbers.slice(3, 6)}`;
      }
      if (numbers.length > 6) {
        formattedValue += `-${numbers.slice(6, 10)}`;
      }
    }

    onChange("client_company_phone", formattedValue);
  };

  const handleFaxChange = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    let formattedValue = numbers;

    if (numbers.length > 3) {
      formattedValue = `(${numbers.slice(0, 3)})`;
      if (numbers.length > 3) {
        formattedValue += ` ${numbers.slice(3, 6)}`;
      }
      if (numbers.length > 6) {
        formattedValue += `-${numbers.slice(6, 10)}`;
      }
    }

    onChange("client_company_fax", formattedValue);
  };
  const handlePhoneChangeAdj = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    let formattedValue = numbers;

    if (numbers.length > 3) {
      formattedValue = `(${numbers.slice(0, 3)})`;
      if (numbers.length > 3) {
        formattedValue += ` ${numbers.slice(3, 6)}`;
      }
      if (numbers.length > 6) {
        formattedValue += `-${numbers.slice(6, 10)}`;
      }
    }

    onChange("client_adjuster_phone", formattedValue);
  };

  const handleFaxChangeAdj = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    let formattedValue = numbers;

    if (numbers.length > 3) {
      formattedValue = `(${numbers.slice(0, 3)})`;
      if (numbers.length > 3) {
        formattedValue += ` ${numbers.slice(3, 6)}`;
      }
      if (numbers.length > 6) {
        formattedValue += `-${numbers.slice(6, 10)}`;
      }
    }

    onChange("client_adjuster_fax", formattedValue);
  };
  const handlePhoneChangeAdjDef = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    let formattedValue = numbers;

    if (numbers.length > 3) {
      formattedValue = `(${numbers.slice(0, 3)})`;
      if (numbers.length > 3) {
        formattedValue += ` ${numbers.slice(3, 6)}`;
      }
      if (numbers.length > 6) {
        formattedValue += `-${numbers.slice(6, 10)}`;
      }
    }

    onChange("defendant_adjuster_phone", formattedValue);
  };

  const handleFaxChangeAdjDef = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    let formattedValue = numbers;

    if (numbers.length > 3) {
      formattedValue = `(${numbers.slice(0, 3)})`;
      if (numbers.length > 3) {
        formattedValue += ` ${numbers.slice(3, 6)}`;
      }
      if (numbers.length > 6) {
        formattedValue += `-${numbers.slice(6, 10)}`;
      }
    }

    onChange("defendant_adjuster_fax", formattedValue);
  };
  const handlePhoneChangeDef = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    let formattedValue = numbers;

    if (numbers.length > 3) {
      formattedValue = `(${numbers.slice(0, 3)})`;
      if (numbers.length > 3) {
        formattedValue += ` ${numbers.slice(3, 6)}`;
      }
      if (numbers.length > 6) {
        formattedValue += `-${numbers.slice(6, 10)}`;
      }
    }

    onChange("defendant_company_phone", formattedValue);
  };

  const handleFaxChangeDef = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    let formattedValue = numbers;

    if (numbers.length > 3) {
      formattedValue = `(${numbers.slice(0, 3)})`;
      if (numbers.length > 3) {
        formattedValue += ` ${numbers.slice(3, 6)}`;
      }
      if (numbers.length > 6) {
        formattedValue += `-${numbers.slice(6, 10)}`;
      }
    }

    onChange("defendant_company_fax", formattedValue);
  };

  const handlePhoneChangeRep = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    let formattedValue = numbers;

    if (numbers.length > 3) {
      formattedValue = `(${numbers.slice(0, 3)})`;
      if (numbers.length > 3) {
        formattedValue += ` ${numbers.slice(3, 6)}`;
      }
      if (numbers.length > 6) {
        formattedValue += `-${numbers.slice(6, 10)}`;
      }
    }

    onChange("defendant_report_phone", formattedValue);
  };

  const handleFaxChangeRep = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    let formattedValue = numbers;

    if (numbers.length > 3) {
      formattedValue = `(${numbers.slice(0, 3)})`;
      if (numbers.length > 3) {
        formattedValue += ` ${numbers.slice(3, 6)}`;
      }
      if (numbers.length > 6) {
        formattedValue += `-${numbers.slice(6, 10)}`;
      }
    }

    onChange("defendant_report_fax", formattedValue);
  };
  const venueCountyRef = useRef(null);
  const [venueCountyDropdown, setVenueCountyDropdown] = useState(false);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (venueCountyRef.current && !venueCountyRef.current.contains(e.target)) {
        setVenueCountyDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <div className="tabclient client-case-category-layout">
        <div
          ref={dropdownRef}
          className="client-case-category-dropdown ps-0 pe-0 custom-select-new-provider"
        >
          <div
            className="dropdown-button client-case-category-dropdown-button form-control p-0 p-l-5 rounded-0 height-25 d-flex align-items-center"
            onClick={() => setDropdownOpen((prev) => !prev)}
            style={{ cursor: "pointer" }}
          >
            <span>
              {selectedCaseCategory
                ? caseTypes?.find((cat) => cat.id === selectedCaseCategory)?.name
                : "Select New Client Case Category"}
            </span>
          </div>
          {dropdownOpen && (
            <div
              className="dropdown-menu p-0 mt-0"
              style={{
                width: "100%",
                border: "1px solid #ced4da",
                maxHeight: "200px",
                overflowY: "auto",
                scrollbarWidth: "none",
              }}
            >
              {caseTypes?.map((type) => (
                <div
                  key={type.id}
                  className="dropdown-option height-25 d-flex align-items-center"
                  style={{
                    cursor: "pointer",
                    paddingLeft: "5px",
                    fontWeight: "600",
                  }}
                  onClick={() => {
                    handleCaseCategoryChange(type?.id);
                    setDropdownOpen(false);
                  }}
                >
                  {type.name}
                </div>
              ))}
            </div>
          )}
        </div>

        {selectedCaseCategory !== 0 && (
          <div
            className="client-case-types d-flex flex-wrap align-items-center"
            style={{ cursor: "pointer" }}
          >
            {filteredCaseTypes?.map((caseType) => (
              <div
                key={caseType.id}
                className="d-flex align-items-center"
                style={{ cursor: "pointer" }}
                // style={{ marginRight: "16px", flexShrink: 0 }}
              >
                <input
                  type="radio"
                  id={`caseType-${caseType.id}`}
                  name="client_case_type"
                  value={caseType.id}
                  checked={data.client_case_type === caseType.id}
                  onChange={() => onChange("client_case_type", caseType.id)}
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "15px",
                    height: "15px",
                    flexShrink: 0,
                    cursor: "pointer",
                  }}
                />
                {caseType?.casetype_icon && (
                  <span
                    className="d-flex align-items-center justify-content-center ic ic-15"
                    style={{ marginLeft: "5px" }}
                  >
                    <img
                      src={caseType.casetype_icon}
                      className=" d-flex align-items-center justify-content-center"
                    />
                  </span>
                )}
                <label
                  htmlFor={`caseType-${caseType.id}`}
                  style={{
                    marginBottom: "0px",
                    marginLeft: "5px",
                    position: "relative",
                    fontWeight: "600",
                  }}
                >
                  {caseType.name}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>

      <CreateNewClientHeader
        sidebarItems={sidebarItems}
        activeTab={activeTab}
        handleTabChange={handleTabChange}
      />

      {activeTab === "required-intake-info" &&
        (loading ? (
          <PulseLoader
            loading={setLoading}
            size={16}
            aria-label="Loading Spinner"
            data-testid="loader"
            color="#19395F"
            style={{
              display: "flex",
              flexDirection: "row",
              height: "calc(100vh-119px)",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
            }}
          />
        ) : (
          <></>
        ))}

      {/* Client Section */}
      {activeTab === "client" &&
        (loading ? (
          <PulseLoader
            loading={setLoading}
            size={16}
            aria-label="Loading Spinner"
            data-testid="loader"
            color="#19395F"
            style={{
              display: "flex",
              flexDirection: "row",
              height: "calc(100vh-119px)",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
            }}
          />
        ) : (
          <>
            <span
              className="w-100"
              style={{
                background: "var(--primary)",
                color: "white",
                fontWeight: "600",
                display: "flex",
                height: "25px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Client Information
            </span>
            <Row className="mx-auto m-b-5 m-t-5">
              <Col sm="4" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Enter New Client First Name"
                    value={data.client_first_name || ""}
                    onChange={(e) => onChange("client_first_name", e.target.value)}
                    // className="haddress2 form-control"
                    className={`form-control height-25 p-0 p-l-5 ${
                      clientNameValidationAttempted && !data.client_first_name?.trim()
                        ? "is-invalid"
                        : ""
                    }`}
                    aria-invalid={clientNameValidationAttempted && !data.client_first_name?.trim()}
                  />
                </FormGroup>
              </Col>
              <Col sm="4" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Enter New Client Middle Name"
                    value={data.client_middle_name || ""}
                    onChange={(e) => onChange("client_middle_name", e.target.value)}
                    className="form-control height-25 p-0 p-l-5"
                  />
                </FormGroup>
              </Col>
              <Col sm="4" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Enter New Client Last Name"
                    value={data.client_last_name || ""}
                    onChange={(e) => onChange("client_last_name", e.target.value)}
                    className={`form-control height-25 p-0 p-l-5 ${
                      clientNameValidationAttempted && !data.client_last_name?.trim()
                        ? "is-invalid"
                        : ""
                    }`}
                    aria-invalid={clientNameValidationAttempted && !data.client_last_name?.trim()}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row className="mx-auto m-b-5">
              <Col sm="2" className="ps-0 p-r-5">
                <FormGroup>
                  <DateInput
                    placeholder="Enter New Client DOB"
                    value={data.client_dob || ""}
                    onChange={(e) => onChange("client_dob", e.target.value)}
                    // className="haddress2"
                    // className={getFieldClass(data.client_dob, true)}
                    className="form-control height-25 p-0 p-l-5"
                  />
                </FormGroup>
              </Col>
              <Col sm="2" className="ps-0 p-r-5">
                <FormGroup>
                  <DateInput
                    placeholder="Enter New Client Incident Date"
                    // className={selectedOptionCase !== null ? "" : "haddress2"}
                    // className={getFieldClass(data.client_incident_date, true)}
                    className="form-control height-25 p-0 p-l-5"
                    value={data.client_incident_date || ""}
                    onChange={(e) => onChange("client_incident_date", e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Col sm="4" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="text"
                    className="form-control height-25 p-l-5 p-0"
                    placeholder="Enter New Client Address 1"
                    value={data.client_address1 || ""}
                    onChange={(e) => onChange("client_address1", e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Col sm="4" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Enter New Client Address 2"
                    value={data.client_address2 || ""}
                    className="form-control height-25 p-l-5 p-0"
                    onChange={(e) => onChange("client_address2", e.target.value)}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row className="mx-auto m-b-5">
              <Col sm="4" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="City"
                    className="form-control height-25 p-l-5 p-0"
                    value={data.client_city || ""}
                    onChange={(e) => onChange("client_city", e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Col sm="2" style={{ paddingLeft: "0px", paddingRight: "5px" }}>
                <FormGroup>
                  <div className="tabclient custom-select-new-provider">
                    <div
                      className={`dropdown-button rounded-0 height-25 p-l-5 form-control d-flex align-items-center ${
                        homeStateClient ? "has-value" : ""
                      }`}
                      onClick={() => setShowStatesModalClient(true)}
                    >
                      <span id="selectedOption">
                        {homeStateClient ? (
                          <div className="d-flex align-items-center">
                            <svg
                              style={{
                                width: "15px",
                                height: "15px",
                                fill: "var(--primary-80)",
                                color: "var(--primary-80)",
                                stroke: "var(--primary-80)",
                              }}
                              className={`icon icon-state-${homeStateClient.StateAbr}`}
                            >
                              <use xlinkHref={`#icon-state-${homeStateClient.StateAbr}`} />
                            </svg>
                            <span className="m-l-5">{homeStateClient.StateAbr}</span>
                          </div>
                        ) : (
                          "State"
                        )}
                      </span>
                    </div>
                  </div>
                </FormGroup>
              </Col>
              <Col sm="2" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="ZIP"
                    className="form-control height-25 p-l-5 p-0"
                    value={data.client_zip || ""}
                    onChange={(e) => onChange("client_zip", e.target.value)}
                  />
                </FormGroup>
              </Col>

              <Col sm="2" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Enter New Client Phone"
                    value={data.client_phone || ""}
                    onChange={handleClientPhoneChange}
                    className="form-control height-25 p-l-5 p-0"
                  />
                  {/* {!isPhoneValid.client_phone && (
                    <>
                      <OverlayTrigger placement="right" overlay={tooltipphone}>
                        <ErrorOutlineIcon
                          style={{
                            marginRight: "-25px",
                            position: "relative",
                            left: "10px",
                            top: "5px",
                          }}
                        />
                      </OverlayTrigger>
                    </>
                  )}
                */}
                </FormGroup>
              </Col>
              <Col sm="2" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="email"
                    placeholder="Enter New Client Email"
                    value={data.client_email || ""}
                    onChange={handleClientEmailChange}
                    className="form-control height-25 p-l-5 p-0"
                  />
                  {/* {!isEmailValid.client_email && (
                    <>
                      <OverlayTrigger placement="right" overlay={tooltip}>
                        <ErrorOutlineIcon
                          style={{
                            marginRight: "-25px",
                            position: "relative",
                            left: "10px",
                            top: "5px",
                          }}
                        />
                      </OverlayTrigger>
                    </>
                  )} */}
                </FormGroup>
              </Col>
            </Row>

            <Row className="mx-auto m-b-5">
              <Col sm="2" className="ps-0 p-r-5">
                <FormGroup>
                  <div
                    className="tabclient custom-select-new-provider"
                    style={{
                      position: "relative",
                    }}
                  >
                    <div
                      className={`dropdown-button rounded-0 form-control height-25 p-l-5 p-0 d-flex align-items-center ${
                        homeStateVenue ? "has-value" : ""
                      }`}
                      onClick={() => setShowStateModalVenue(true)}
                    >
                      <span id="selectedOption">
                        {homeStateVenue ? (
                          <div className="d-flex align-items-center">
                            <svg
                              style={{
                                width: "15px",
                                height: "15px",
                                fill: "var(--primary-80)",
                                color: "var(--primary-80)",
                                stroke: "var(--primary-80)",
                              }}
                              className={`icon icon-state-${homeStateVenue.StateAbr}`}
                            >
                              <use xlinkHref={`#icon-state-${homeStateVenue.StateAbr}`} />
                            </svg>
                            <span className="m-l-5">{homeStateVenue.StateAbr}</span>
                          </div>
                        ) : (
                          "First Select Venue State"
                        )}
                      </span>
                    </div>
                  </div>
                </FormGroup>
              </Col>

              {fieldStates.venue_county && (
                // <Col sm="2" className="ps-0 p-r-5">
                //   <FormGroup>
                //     <FormControl
                //       as="select"
                //       disabled={selectedState === ""}
                //       value={data.intake_venue_county || ""}
                //       onChange={(e) => onChange("intake_venue_county", e.target.value)}
                //       // className={getFieldClass(data.intake_venue_county, true)}
                //       className="form-control height-25 p-0 p-l-5"
                //     >
                //       <option value="">Then Select Venue County</option>
                //       {filteredVenue?.map((venue) => (
                //         <option key={venue.id} value={venue.name}>
                //           {venue.name}
                //         </option>
                //       ))}
                //     </FormControl>
                //   </FormGroup>
                // </Col>
                <Col sm="2" className="ps-0 p-r-5">
                  <div
                    ref={venueCountyRef}
                    className="height-25 p-l-0 p-r-5 custom-select-new-provider position-relative"
                  >
                    <div
                      className="dropdown-button form-control pt-0 pb-0 pe-0 rounded-0 height-25 d-flex align-items-center"
                      onClick={() =>
                        selectedState !== "" && setVenueCountyDropdown((prev) => !prev)
                      }
                      style={{
                        paddingLeft: data.intake_venue_county ? "0px" : "5px",
                        background: "white",
                        cursor: selectedState === "" ? "not-allowed" : "pointer",
                        opacity: selectedState === "" ? 1 : 1,
                        color: selectedState === "" ? "var(--primary-25)" : "black",
                      }}
                    >
                      <span>
                        {data.intake_venue_county ? (
                          <div
                            className="d-flex p-l-5 align-items-center justify-content-start"
                            style={{
                              height: "25px",
                              fontSize: "16px",
                              color: "black",
                              fontWeight: "700",
                              gap: "5px",
                            }}
                          >
                            {data.intake_venue_county}
                          </div>
                        ) : (
                          "Then Select Venue County"
                        )}
                      </span>
                    </div>

                    {venueCountyDropdown && (
                      <div
                        className="dropdown-menu p-0 mt-0"
                        style={{
                          width: "98%",
                          border: "1px solid #ced4da",
                          scrollbarWidth: "none",
                          maxHeight: "250px",
                          fontSize: "14px",
                          overflowY: "auto",
                        }}
                      >
                        {filteredVenue?.map((venue) => (
                          <div className="dropdown-source-type" key={venue.id}>
                            <div
                              className="dropdown-option d-flex align-items-center height-25"
                              style={{
                                color: "black",
                                fontWeight: "700",
                                fontSize: "14px",
                                cursor: "pointer",
                                paddingLeft: "5px",
                              }}
                              onClick={() => {
                                onChange("intake_venue_county", venue.name);
                                setVenueCountyDropdown(false);
                              }}
                            >
                              {venue.name}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </Col>
              )}
            </Row>

            <span
              className="w-100"
              style={{
                background: "var(--primary)",
                color: "white",
                fontWeight: "600",
                display: "flex",
                height: "25px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Insurance Information
            </span>
            <Row className="mx-auto m-t-5 mb-0">
              <div
                ref={insuranceTypeRef}
                className="col-md-3 ps-0 p-r-5 custom-select-new-provider"
                style={{ position: "relative" }}
              >
                <div
                  className={`dropdown-button form-control p-0 p-l-5 rounded-0 height-25 d-flex align-items-center ${getFieldClass(
                    data.client_insurance_type,
                    false
                  )}`}
                  onClick={() => setInsuranceTypeOpen((prev) => !prev)}
                  style={{ cursor: "pointer" }}
                >
                  <span>
                    {data.client_insurance_type
                      ? insuranceNewTypes?.find((t) => t.id === data.client_insurance_type)?.name
                      : "Select New Client Insurance Type"}
                  </span>
                </div>

                {insuranceTypeOpen && (
                  <div
                    className="dropdown-menu p-0 mt-0"
                    style={{
                      width: "99%",
                      border: "1px solid #ced4da",
                      maxHeight: "200px",
                      overflowY: "auto",
                      scrollbarWidth: "none",
                    }}
                  >
                    <div
                      className="dropdown-option height-25 d-flex align-items-center"
                      style={{ cursor: "pointer", paddingLeft: "5px" }}
                      onClick={() => {
                        onChange("client_insurance_type", 0);
                        setInsuranceTypeOpen(false);
                      }}
                    >
                      Select New Client Insurance Type
                    </div>

                    {insuranceNewTypes?.map((type) => (
                      <div
                        key={type.id}
                        className="dropdown-option height-25 d-flex align-items-center"
                        style={{
                          cursor: "pointer",
                          paddingLeft: "5px",
                          fontWeight: "600",
                        }}
                        onClick={() => {
                          onChange("client_insurance_type", type.id);
                          setInsuranceTypeOpen(false);
                        }}
                      >
                        {type.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <Col sm="3" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="text"
                    className="form-control height-25 p-l-5 p-0"
                    placeholder="Enter New Client Policy #"
                    value={data.client_policy_number || ""}
                    onChange={(e) => onChange("client_policy_number", e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Col sm="3" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Enter New Client Claim #"
                    className="form-control height-25 p-l-5 p-0"
                    value={data.client_claim_number || ""}
                    onChange={(e) => onChange("client_claim_number", e.target.value)}
                  />
                </FormGroup>
              </Col>

              {fieldStates.jurisdiction && (
                <Col sm="3" className="ps-0 p-r-5">
                  <FormGroup>
                    <FormControl
                      type="text"
                      placeholder="Enter Jurisdiction"
                      value={data.intake_jurisdiction || ""}
                      onChange={(e) => onChange("intake_jurisdiction", e.target.value)}
                      // className="haddress2"
                      className="form-control height-25 p-l-5 p-0"
                    />
                  </FormGroup>
                </Col>
              )}
            </Row>

            <Row className="mx-0">
              <Col ref={companySearchRef} md={12} className="ps-0 p-r-5">
                <Form.Control
                  type="text"
                  name="search_filter_insurance_input"
                  value={companySearchInput}
                  placeholder="Type Insurance Company name to search directory then click an entry"
                  className="custom-margin-top custom-margin-bottom height-25 p-0 p-l-5 rounded-0"
                  onChange={(e) => {
                    setCompanySearchInput(e.target.value);
                    handleSearchInsurances(e, "company");
                  }}
                />
                {companySearchInput && (
                  <span
                    onClick={() => {
                      setCompanySearchInput("");
                      handleSearchInsurances({ target: { value: "" } }, "company");
                      onChange("client_insurance_company_id", "");
                      onChange("client_company_name", "");
                      onChange("client_company_address1", "");
                      onChange("client_company_address2", "");
                      onChange("client_company_city", "");
                      onChange("client_company_state", "");
                      onChange("client_company_zip", "");
                      onChange("client_company_phone", "");
                      onChange("client_company_extension_field", "");
                      onChange("client_company_fax", "");
                      onChange("client_company_email", "");
                      onChange("client_company_website", "");
                    }}
                    style={{
                      position: "absolute",
                      right: "15px",
                      top: "10px",
                      cursor: "pointer",
                      fontSize: "14px",
                      color: "black",
                      lineHeight: 1,
                      userSelect: "none",
                    }}
                  >
                    ✕
                  </span>
                )}
                {searchedInsurances.length > 0 && (
                  <AutoCompleteSearch
                    searchedInsurances={searchedInsurances}
                    selectedInsurance={(data) => handleSelectedInsuranceTabs("company", data)}
                    isCompany={true}
                  />
                )}
              </Col>
            </Row>
            <Row className="mx-0 p-l-5">
              <ContactPanelForEditPopups
                panel_name={"Insurance Company"}
                className="m-b-5"
                dynamic_label={"Company Name"}
                name={data?.client_company_name}
                address1={data?.client_company_address1}
                address2={data?.client_company_address2}
                email={data?.client_company_email}
                phone_number={data?.client_company_phone}
                city={data?.client_company_city}
                state={data?.client_company_state}
                zip_code={data?.client_company_zip}
                fax_number={data?.client_company_fax}
                ext={data?.client_company_extension_field}
                websiteURL={data?.client_company_website}
                buttonData={InsuranceButtons}
                pageName="Case Loans"
              />

              <Col md={"auto"} className="p-0 d-flex-1">
                <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Name"
                    value={data?.client_company_name || ""}
                    onChange={(e) => onChange("client_company_name", e.target.value)}
                  />
                </div>
                <Row className="align-items-center custom-margin-bottom mx-0">
                  <div className="d-flex-1 p-r-5 p-l-0">
                    <Form.Control
                      type="text"
                      className="height-25 p-0 p-l-5 rounded-0"
                      placeholder="Address 1"
                      value={data?.client_company_address1 || ""}
                      onChange={(e) => onChange("client_company_address1", e.target.value)}
                    />
                  </div>
                  <div className="d-flex-1 p-l-0 p-r-5">
                    <Form.Control
                      type="text"
                      className="height-25 p-0 p-l-5 rounded-0"
                      placeholder="Address 2"
                      value={data?.client_company_address2 || ""}
                      onChange={(e) => onChange("client_company_address2", e.target.value)}
                    />
                  </div>
                </Row>
                <Row className="align-items-center custom-margin-bottom mx-0">
                  <div className="d-flex-1 p-l-0 p-r-5">
                    <Form.Control
                      type="text"
                      placeholder="City"
                      className="form-control height-25 p-0 p-l-5 rounded-0"
                      value={data?.client_company_city || ""}
                      onChange={(e) => onChange("client_company_city", e.target.value)}
                    />
                  </div>
                  <div className="d-flex-1 p-l-0 position-relative height-25 p-r-5 custom-select-new-provider">
                    <div
                      className="dropdown-button rounded-0 p-0 p-l-5 form-control height-25 d-flex align-items-center"
                      onClick={handleStateShow}
                    >
                      <span id="selectedOption">
                        {data?.client_company_state ? (
                          <div className="d-flex align-items-center">
                            <svg
                              style={{
                                width: "15px",
                                height: "15px",
                                fill: "var(--primary-80)",
                                color: "var(--primary-80)",
                                stroke: "var(--primary-80)",
                              }}
                              className={`icon icon-state-${data?.client_company_state}`}
                            >
                              <use xlinkHref={`#icon-state-${data?.client_company_state}`} />
                            </svg>
                            {data?.client_company_state}
                          </div>
                        ) : (
                          "Select State"
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex-1 p-r-5">
                    <Form.Control
                      type="text"
                      placeholder="Zip"
                      className="height-25 p-0 p-l-5 rounded-0"
                      value={data?.client_company_zip || ""}
                      onChange={(e) => onChange("client_company_zip", e.target.value)}
                    />
                  </div>
                </Row>
                <Row className="align-items-center custom-margin-bottom mx-0">
                  <div className="d-flex-1 p-r-5 p-l-0">
                    <Form.Control
                      type="text"
                      placeholder="(###) ###-####"
                      className="height-25 p-0 p-l-5 rounded-0"
                      value={data?.client_company_phone || ""}
                      onChange={(e) => handlePhoneChange(e)}
                    />
                  </div>

                  <div className="d-flex-1 p-l-0 p-r-5">
                    <Form.Control
                      type="text"
                      placeholder="Extension"
                      className="form-control height-25 p-0 p-l-5 rounded-0"
                      value={data?.client_company_extension_field || ""}
                      onChange={(e) => onChange("client_company_extension_field", e.target.value)}
                    />
                  </div>

                  <div className="d-flex-1 p-l-0 p-r-5">
                    <Form.Control
                      type="text"
                      placeholder="(###) ###-#### - fax"
                      className="height-25 p-0 p-l-5 rounded-0"
                      value={data?.client_company_fax || ""}
                      onChange={(e) => handleFaxChange(e)}
                    />
                  </div>
                </Row>
                <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Email"
                    value={data?.client_company_email || ""}
                    onChange={(e) => onChange("client_company_email", e.target.value)}
                  />
                </div>

                <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Website"
                    value={data?.client_company_website || ""}
                    onChange={(e) => onChange("client_company_website", e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="mx-0">
              <Col ref={adjusterSearchRef} md={12} className="ps-0 p-r-5">
                <Form.Control
                  type="text"
                  name="search_filter_adjuster_input"
                  value={adjusterSearchInput}
                  placeholder="Type Insurance Adjuster name to search directory then click an entry"
                  className="custom-margin-top custom-margin-bottom  mt-0 height-25 p-0 p-l-5 rounded-0"
                  onChange={(e) => {
                    setAdjusterSearchInput(e.target.value);
                    handleSearchInsurances(e, "adjuster");
                  }}
                />
                {adjusterSearchInput && (
                  <span
                    onClick={() => {
                      setAdjusterSearchInput("");
                      onChange("client_insurance_adjuster_id", "");
                      handleSearchInsurances({ target: { value: "" } }, "adjuster");
                      onChange("client_adjuster_first_name", "");
                      onChange("client_adjuster_last_name", "");
                      onChange("client_adjuster_address1", "");
                      onChange("client_adjuster_address2", "");
                      onChange("client_adjuster_city", "");
                      onChange("client_adjuster_state", "");
                      onChange("client_adjuster_zip", "");
                      onChange("client_adjuster_phone", "");
                      onChange("client_adjuster_extension_field", "");
                      onChange("client_adjuster_fax", "");
                      onChange("client_adjuster_email", "");
                      onChange("client_adjuster_website", "");
                    }}
                    style={{
                      position: "absolute",
                      right: "15px",
                      top: "5px",
                      cursor: "pointer",
                      fontSize: "14px",
                      color: "black",
                      lineHeight: 1,
                      userSelect: "none",
                    }}
                  >
                    ✕
                  </span>
                )}
                {searchedAjusters.length > 0 && (
                  <AutoCompleteSearch
                    searchedInsurances={searchedAjusters}
                    selectedInsurance={(data) => handleSelectedInsuranceTabs("adjuster", data)}
                    isAdjuster={true}
                  />
                )}
              </Col>
            </Row>
            <Row className="mx-0 p-l-5">
              <div style={{ width: "260px" }}>
                <ContactPanelForEditPopups
                  panel_name={"Adjuster"}
                  className="m-b-5"
                  name={`${data?.client_adjuster_first_name || ""} ${data?.client_adjuster_last_name || ""}`}
                  address1={data?.client_adjuster_address1}
                  address2={data?.client_adjuster_address2}
                  email={data?.client_adjuster_email}
                  phone_number={data?.client_adjuster_phone}
                  city={data?.client_adjuster_city}
                  state={data?.client_adjuster_state}
                  zip_code={data?.client_adjuster_zip}
                  fax_number={data?.client_adjuster_fax}
                  ext={data?.client_adjuster_extension_field}
                  websiteURL={data?.client_adjuster_website}
                  buttonData={InsuranceButtons}
                  pageName="Case Loans"
                />
              </div>
              <Col md={"auto"} className="p-0 d-flex-1">
                <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                  <div
                    className="d-flex align-items-center"
                    style={{
                      gap: "5px",
                    }}
                  >
                    <Form.Control
                      type="text"
                      className="height-25 p-0 p-l-5 rounded-0"
                      placeholder="Adjuster First Name"
                      value={data?.client_adjuster_first_name || ""}
                      onChange={(e) => onChange("client_adjuster_first_name", e.target.value)}
                    />
                    <Form.Control
                      type="text"
                      className="height-25 p-0 p-l-5 rounded-0"
                      placeholder="Adjuster Last Name"
                      value={data?.client_adjuster_last_name || ""}
                      onChange={(e) => onChange("client_adjuster_last_name", e.target.value)}
                    />
                  </div>
                </div>
                <Row className="align-items-center custom-margin-bottom mx-0">
                  <div className="d-flex-1 p-r-5 p-l-0">
                    <Form.Control
                      type="text"
                      className="height-25 p-0 p-l-5 rounded-0"
                      placeholder="Address 1"
                      value={data?.client_adjuster_address1 || ""}
                      onChange={(e) => onChange("client_adjuster_address1", e.target.value)}
                    />
                  </div>
                  <div className="d-flex-1 p-l-0 p-r-5">
                    <Form.Control
                      type="text"
                      className="height-25 p-0 p-l-5 rounded-0"
                      placeholder="Address 2"
                      value={data?.client_adjuster_address2 || ""}
                      onChange={(e) => onChange("client_adjuster_address2", e.target.value)}
                    />
                  </div>
                </Row>
                <Row className="align-items-center custom-margin-bottom mx-0">
                  <div className="d-flex-1 p-l-0 p-r-5">
                    <Form.Control
                      type="text"
                      placeholder="City"
                      className="form-control height-25 p-0 p-l-5 rounded-0"
                      value={data?.client_adjuster_city || ""}
                      onChange={(e) => onChange("client_adjuster_city", e.target.value)}
                    />
                  </div>
                  <div className="d-flex-1 p-l-0 position-relative height-25 p-r-5 custom-select-new-provider">
                    <div
                      className="dropdown-button rounded-0 p-0 p-l-5 form-control height-25 d-flex align-items-center"
                      onClick={handleAdjusterStateShow}
                    >
                      <span id="selectedOption">
                        {data?.client_adjuster_state ? (
                          <div className="d-flex align-items-center">
                            <svg
                              style={{
                                width: "15px",
                                height: "15px",
                                fill: "var(--primary-80)",
                                color: "var(--primary-80)",
                                stroke: "var(--primary-80)",
                              }}
                              className={`icon icon-state-${data?.client_adjuster_state}`}
                            >
                              <use xlinkHref={`#icon-state-${data?.client_adjuster_state}`} />
                            </svg>
                            {data?.client_adjuster_state}
                          </div>
                        ) : (
                          "Select State"
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex-1 p-r-5">
                    <Form.Control
                      type="text"
                      placeholder="Zip"
                      className="height-25 p-0 p-l-5 rounded-0"
                      value={data?.client_adjuster_zip || ""}
                      onChange={(e) => onChange("client_adjuster_zip", e.target.value)}
                    />
                  </div>
                </Row>
                <Row className="align-items-center custom-margin-bottom mx-0">
                  <div className="d-flex-1 p-r-5 p-l-0">
                    <Form.Control
                      type="text"
                      placeholder="(###) ###-####"
                      className="height-25 p-0 p-l-5 rounded-0"
                      value={data?.client_adjuster_phone || ""}
                      onChange={(e) => handlePhoneChangeAdj(e)}
                    />
                  </div>

                  <div className="d-flex-1 p-l-0 p-r-5">
                    <Form.Control
                      type="text"
                      placeholder="Extension"
                      className="form-control height-25 p-0 p-l-5 rounded-0"
                      value={data?.client_adjuster_extension_field || ""}
                      onChange={(e) => onChange("client_adjuster_extension_field", e.target.value)}
                    />
                  </div>

                  <div className="d-flex-1 p-l-0 p-r-5">
                    <Form.Control
                      type="text"
                      placeholder="(###) ###-#### - fax"
                      className="height-25 p-0 p-l-5 rounded-0"
                      value={data?.client_adjuster_fax || ""}
                      onChange={(e) => handleFaxChangeAdj(e)}
                    />
                  </div>
                </Row>
                <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Email"
                    value={data?.client_adjuster_email || ""}
                    onChange={(e) => onChange("client_adjuster_email", e.target.value)}
                  />
                </div>

                <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Website"
                    value={data?.client_adjuster_website || ""}
                    onChange={(e) => onChange("client_adjuster_website", e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <div className="text-end d-flex align-items-center justify-content-end">
              <Button
                variant="primary"
                onClick={() => handleTabChange("defendant")}
                className="height-25 d-flex align-items-center justify-content-center"
              >
                Next
              </Button>
            </div>
          </>
        ))}

      {/* Defendant Section */}
      {activeTab === "defendant" && (
        <>
          <span
            className="w-100"
            style={{
              background: "var(--primary)",
              color: "white",
              fontWeight: "600",
              display: "flex",
              height: "25px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Defendant Information
          </span>
          <div
            className="col-md-4 m-t-5 ps-0 p-r-5 custom-select-new-provider"
            style={{ position: "relative" }}
          >
            <div
              className={`dropdown-button form-control p-0 p-l-5 rounded-0 height-25 d-flex align-items-center ${getFieldClass(
                data.defendant_type || 1,
                false
              )}`}
              onClick={() => setDefendantTypeOpen((prev) => !prev)}
              style={{ cursor: "pointer" }}
            >
              <span>
                {(() => {
                  const selected = defendantTypes?.find((t) => t.id === (data.defendant_type || 1));
                  return selected ? selected.name : "Private Individual";
                })()}
              </span>
            </div>

            {defendantTypeOpen && (
              <div
                className="dropdown-menu p-0 mt-0"
                style={{
                  width: "99%",
                  border: "1px solid #ced4da",
                  maxHeight: "200px",
                  overflowY: "auto",
                  scrollbarWidth: "none",
                }}
              >
                {defendantTypes?.map((type) => (
                  <div
                    key={type.id}
                    className="dropdown-option height-25 d-flex align-items-center"
                    style={{
                      cursor: "pointer",
                      paddingLeft: "5px",
                      fontWeight: "600",
                    }}
                    onClick={() => {
                      onChange("defendant_type", type.id);
                      setDefendantTypeOpen(false);
                      setDefendantTypeId(type?.id);
                    }}
                  >
                    {type.name}
                  </div>
                ))}
              </div>
            )}
          </div>
          {defendantTypeId === 1 ? (
            <Row className="mx-auto m-b-5 m-t-5">
              <Col sm="4" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Enter Defendant First Name"
                    value={data.defendant_first_name || ""}
                    onChange={(e) => onChange("defendant_first_name", e.target.value)}
                    className="form-control height-25 p-0 p-l-5"
                  />
                </FormGroup>
              </Col>
              <Col sm="4" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Enter Defendant Middle Name"
                    value={data.defendant_middle_name || ""}
                    onChange={(e) => onChange("defendant_middle_name", e.target.value)}
                    className="form-control height-25 p-0 p-l-5"
                  />
                </FormGroup>
              </Col>
              <Col sm="4" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Enter Defendant Last Name"
                    value={data.defendant_last_name || ""}
                    onChange={(e) => onChange("defendant_last_name", e.target.value)}
                    className="form-control height-25 p-0 p-l-5"
                  />
                </FormGroup>
              </Col>
            </Row>
          ) : (
            <Row className="mx-auto m-b-5 m-t-5">
              <Col sm="4" className="ps-0 p-r-5">
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Enter Defendant Entity Name"
                    value={data.defendant_entity_name || ""}
                    onChange={(e) => onChange("defendant_entity_name", e.target.value)}
                    className="form-control height-25 p-0 p-l-5"
                  />
                </FormGroup>
              </Col>
            </Row>
          )}

          {defendantTypeId === 1 && (
            <Row className="mx-auto m-b-5">
              <Col sm="4" className="ps-0 p-r-5">
                <FormGroup>
                  <DateInput
                    placeholder="Enter Defendant Birthday"
                    value={formatCalendarDateForInput(data.defendant_dob)}
                    onChange={(e) => onChange("defendant_dob", e.target.value)}
                    className="form-control height-25 p-0 p-l-5"
                  />
                </FormGroup>
              </Col>
            </Row>
          )}

          <Row className="mx-auto m-b-5">
            <Col sm="4" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  placeholder="Enter Address 1"
                  value={data.defendant_address1 || ""}
                  onChange={(e) => onChange("defendant_address1", e.target.value)}
                  className="form-control height-25 p-0 p-l-5"
                />
              </FormGroup>
            </Col>
            <Col sm="4" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  placeholder="Enter Address 2"
                  value={data.defendant_address2 || ""}
                  onChange={(e) => onChange("defendant_address2", e.target.value)}
                  className="form-control height-25 p-0 p-l-5"
                />
              </FormGroup>
            </Col>
          </Row>

          <Row className="mx-auto m-b-5">
            <Col sm="4" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  placeholder="Enter City"
                  value={data.defendant_city || ""}
                  onChange={(e) => onChange("defendant_city", e.target.value)}
                  className="form-control height-25 p-l-5 p-0"
                />
              </FormGroup>
            </Col>
            <Col sm="2" style={{ paddingLeft: "0px", paddingRight: "5px" }}>
              <FormGroup>
                <div className="tabclient custom-select-new-provider">
                  <div
                    className={`dropdown-button rounded-0 form-control height-25 p-l-5 p-0 d-flex align-items-center ${
                      homeStateDefendant ? "has-value" : ""
                    }`}
                    onClick={() => setShowStatesModalDefendant(true)}
                  >
                    <span id="selectedOption">
                      {homeStateDefendant ? (
                        <div className="d-flex align-items-center">
                          <svg
                            style={{
                              width: "15px",
                              height: "15px",
                              fill: "var(--primary-80)",
                              color: "var(--primary-80)",
                              stroke: "var(--primary-80)",
                            }}
                            className={`icon icon-state-${homeStateDefendant.StateAbr}`}
                          >
                            <use xlinkHref={`#icon-state-${homeStateDefendant.StateAbr}`} />
                          </svg>
                          <span className="m-l-5">{homeStateDefendant.StateAbr}</span>
                        </div>
                      ) : (
                        "Select State"
                      )}
                    </span>
                  </div>
                </div>
              </FormGroup>
            </Col>
            <Col sm="2" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  placeholder="ZIP"
                  value={data.defendant_zip || ""}
                  onChange={(e) => onChange("defendant_zip", e.target.value)}
                  className="form-control height-25 p-l-5 p-0"
                />
              </FormGroup>
            </Col>

            <Col sm="2" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  placeholder="Enter Defendant Phone"
                  value={data.defendant_phone || ""}
                  onChange={handleDefendantPhoneChange}
                  className="form-control height-25 p-l-5 p-0"
                />
              </FormGroup>
            </Col>
            <Col sm="2" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="email"
                  placeholder="Enter Defendant Email"
                  value={data.defendant_email || ""}
                  onChange={handleDefendantEmailChange}
                  className="form-control height-25 p-l-5 p-0"
                />
              </FormGroup>
            </Col>
          </Row>
          <span
            className="w-100"
            style={{
              background: "var(--primary)",
              color: "white",
              fontWeight: "600",
              display: "flex",
              height: "25px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Insurance Information
          </span>
          <Row className="mx-auto m-t-5 mb-0">
            <div
              ref={defInsuranceTypeRef}
              className="col-md-3 ps-0 p-r-5 custom-select-new-provider"
              style={{ position: "relative" }}
            >
              <div
                className={`dropdown-button form-control p-0 p-l-5 rounded-0 height-25 d-flex align-items-center ${getFieldClass(
                  data.defendant_insurance_type,
                  false
                )}`}
                onClick={() => setDefInsuranceTypeOpen((prev) => !prev)}
                style={{ cursor: "pointer" }}
              >
                <span>
                  {data.defendant_insurance_type
                    ? insuranceNewTypes?.find((t) => t.id === data.defendant_insurance_type)?.name
                    : "Select New Defendant Insurance Type"}
                </span>
              </div>

              {defInsuranceTypeOpen && (
                <div
                  className="dropdown-menu p-0 mt-0"
                  style={{
                    width: "99%",
                    border: "1px solid #ced4da",
                    maxHeight: "200px",
                    overflowY: "auto",
                    scrollbarWidth: "none",
                  }}
                >
                  <div
                    className="dropdown-option height-25 d-flex align-items-center"
                    style={{ cursor: "pointer", paddingLeft: "5px" }}
                    onClick={() => {
                      onChange("defendant_insurance_type", 0);
                      setDefInsuranceTypeOpen(false);
                    }}
                  >
                    Select New Defendant Insurance Type
                  </div>

                  {insuranceNewTypes?.map((type) => (
                    <div
                      key={type.id}
                      className="dropdown-option height-25 d-flex align-items-center"
                      style={{
                        cursor: "pointer",
                        paddingLeft: "5px",
                        fontWeight: "600",
                      }}
                      onClick={() => {
                        onChange("defendant_insurance_type", type.id);
                        setDefInsuranceTypeOpen(false);
                      }}
                    >
                      {type.name}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <Col sm="3" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  className="form-control height-25 p-l-5 p-0"
                  placeholder="Enter New Defendant Policy #"
                  value={data.defendant_policy_number || ""}
                  onChange={(e) => onChange("defendant_policy_number", e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col sm="3" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  placeholder="Enter New Defendant Claim #"
                  className="form-control height-25 p-l-5 p-0"
                  value={data.defendant_claim_number || ""}
                  onChange={(e) => onChange("defendant_claim_number", e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row className="mx-0">
            <Col ref={defCompanySearchRef} md={12} className="ps-0 p-r-5">
              <Form.Control
                type="text"
                name="search_filter_insurance_input"
                value={companySearchInputDef}
                placeholder="Type Insurance Company name to search directory then click an entry"
                className="custom-margin-top custom-margin-bottom height-25 p-0 p-l-5 rounded-0"
                onChange={(e) => {
                  setCompanySearchInputDef(e.target.value);
                  handleSearchInsurancesDef(e, "company");
                }}
              />
              {companySearchInputDef && (
                <span
                  onClick={() => {
                    setCompanySearchInputDef("");
                    handleSearchInsurancesDef({ target: { value: "" } }, "company");
                    onChange("defendant_company_id", "");
                    onChange("defendant_company_name", "");
                    onChange("defendant_company_address1", "");
                    onChange("defendant_company_address2", "");
                    onChange("defendant_company_city", "");
                    onChange("defendant_company_state", "");
                    onChange("defendant_company_zip", "");
                    onChange("defendant_company_phone", "");
                    onChange("defendant_company_extension_field", "");
                    onChange("defendant_company_fax", "");
                    onChange("defendant_company_email", "");
                    onChange("defendant_company_website", "");
                  }}
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "10px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "black",
                    lineHeight: 1,
                    userSelect: "none",
                  }}
                >
                  ✕
                </span>
              )}
              {searchedInsurancesDef.length > 0 && (
                <AutoCompleteSearch
                  searchedInsurances={searchedInsurancesDef}
                  selectedInsurance={(data) => handleSelectedInsuranceTabsDef("company", data)}
                  isCompany={true}
                />
              )}
            </Col>
          </Row>

          <Row className="mx-0 p-l-5">
            <ContactPanelForEditPopups
              panel_name={"Insurance Company"}
              className="m-b-5"
              dynamic_label={"Company Name"}
              name={data?.defendant_company_name}
              address1={data?.defendant_company_address1}
              address2={data?.defendant_company_address2}
              email={data?.defendant_company_email}
              phone_number={data?.defendant_company_phone}
              city={data?.defendant_company_city}
              state={data?.defendant_company_state}
              zip_code={data?.defendant_company_zip}
              fax_number={data?.defendant_company_fax}
              ext={data?.defendant_company_extension_field}
              websiteURL={data?.defendant_company_website}
              buttonData={InsuranceButtons}
              pageName="Case Loans"
            />

            <Col md={"auto"} className="p-0 d-flex-1">
              <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                <Form.Control
                  type="text"
                  className="height-25 p-0 p-l-5 rounded-0"
                  placeholder="Name"
                  value={data?.defendant_company_name || ""}
                  onChange={(e) => onChange("defendant_company_name", e.target.value)}
                />
              </div>
              <Row className="align-items-center custom-margin-bottom mx-0">
                <div className="d-flex-1 p-r-5 p-l-0">
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Address 1"
                    value={data?.defendant_company_address1 || ""}
                    onChange={(e) => onChange("defendant_company_address1", e.target.value)}
                  />
                </div>
                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Address 2"
                    value={data?.defendant_company_address2 || ""}
                    onChange={(e) => onChange("defendant_company_address2", e.target.value)}
                  />
                </div>
              </Row>
              <Row className="align-items-center custom-margin-bottom mx-0">
                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="City"
                    className="form-control height-25 p-0 p-l-5 rounded-0"
                    value={data?.defendant_company_city || ""}
                    onChange={(e) => onChange("defendant_company_city", e.target.value)}
                  />
                </div>
                <div className="d-flex-1 p-l-0 position-relative height-25 p-r-5 custom-select-new-provider">
                  <div
                    className="dropdown-button rounded-0 p-0 p-l-5 form-control height-25 d-flex align-items-center"
                    onClick={handleStateShowDef}
                  >
                    <span id="selectedOption">
                      {data?.defendant_company_state ? (
                        <div className="d-flex align-items-center">
                          <svg
                            style={{
                              width: "15px",
                              height: "15px",
                              fill: "var(--primary-80)",
                              color: "var(--primary-80)",
                              stroke: "var(--primary-80)",
                            }}
                            className={`icon icon-state-${data?.defendant_company_state}`}
                          >
                            <use xlinkHref={`#icon-state-${data?.defendant_company_state}`} />
                          </svg>
                          {data?.defendant_company_state}
                        </div>
                      ) : (
                        "Select State"
                      )}
                    </span>
                  </div>
                </div>
                <div className="d-flex-1 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="Zip"
                    className="height-25 p-0 p-l-5 rounded-0"
                    value={data?.defendant_company_zip || ""}
                    onChange={(e) => onChange("defendant_company_zip", e.target.value)}
                  />
                </div>
              </Row>
              <Row className="align-items-center custom-margin-bottom mx-0">
                <div className="d-flex-1 p-r-5 p-l-0">
                  <Form.Control
                    type="text"
                    placeholder="(###) ###-####"
                    className="height-25 p-0 p-l-5 rounded-0"
                    value={data?.defendant_company_phone || ""}
                    onChange={(e) => handlePhoneChangeDef(e)}
                  />
                </div>

                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="Extension"
                    className="form-control height-25 p-0 p-l-5 rounded-0"
                    value={data?.defendant_company_extension_field || ""}
                    onChange={(e) => onChange("defendant_company_extension_field", e.target.value)}
                  />
                </div>

                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="(###) ###-#### - fax"
                    className="height-25 p-0 p-l-5 rounded-0"
                    value={data?.defendant_company_fax || ""}
                    onChange={(e) => handleFaxChangeDef(e)}
                  />
                </div>
              </Row>
              <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                <Form.Control
                  type="text"
                  className="height-25 p-0 p-l-5 rounded-0"
                  placeholder="Email"
                  value={data?.defendant_company_email || ""}
                  onChange={(e) => onChange("defendant_company_email", e.target.value)}
                />
              </div>

              <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                <Form.Control
                  type="text"
                  className="height-25 p-0 p-l-5 rounded-0"
                  placeholder="Website"
                  value={data?.defendant_company_website || ""}
                  onChange={(e) => onChange("defendant_company_website", e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row className="mx-0">
            <Col ref={defAdjusterSearchRef} md={12} className="ps-0 p-r-5">
              <Form.Control
                type="text"
                name="search_filter_adjuster_input"
                value={adjusterSearchInputDef}
                placeholder="Type Insurance Adjuster name to search directory then click an entry"
                className="custom-margin-top custom-margin-bottom height-25 mt-0 p-0 p-l-5 rounded-0"
                onChange={(e) => {
                  setAdjusterSearchInputDef(e.target.value);
                  handleSearchInsurancesDef(e, "adjuster");
                }}
              />
              {adjusterSearchInputDef && (
                <span
                  onClick={() => {
                    setAdjusterSearchInputDef("");
                    handleSearchInsurancesDef({ target: { value: "" } }, "adjuster");
                    onChange("defendant_adjuster_id", "");
                    onChange("defendant_adjuster_first_name", "");
                    onChange("defendant_adjuster_last_name", "");
                    onChange("defendant_adjuster_address1", "");
                    onChange("defendant_adjuster_address2", "");
                    onChange("defendant_adjuster_city", "");
                    onChange("defendant_adjuster_state", "");
                    onChange("defendant_adjuster_zip", "");
                    onChange("defendant_adjuster_phone", "");
                    onChange("defendant_adjuster_extension_field", "");
                    onChange("defendant_adjuster_fax", "");
                    onChange("defendant_adjuster_email", "");
                    onChange("defendant_adjuster_website", "");
                  }}
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "5px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "black",
                    lineHeight: 1,
                    userSelect: "none",
                  }}
                >
                  ✕
                </span>
              )}
              {searchedAjustersDef.length > 0 && (
                <AutoCompleteSearch
                  searchedInsurances={searchedAjustersDef}
                  selectedInsurance={(data) => handleSelectedInsuranceTabsDef("adjuster", data)}
                  isAdjuster={true}
                />
              )}
            </Col>
          </Row>
          <Row className="mx-0 p-l-5">
            <div style={{ width: "260px" }}>
              <ContactPanelForEditPopups
                panel_name={"Adjuster"}
                className="m-b-5"
                name={`${data?.defendant_adjuster_first_name || ""} ${data?.defendant_adjuster_last_name || ""}`}
                address1={data?.defendant_adjuster_address1}
                address2={data?.defendant_adjuster_address2}
                email={data?.defendant_adjuster_email}
                phone_number={data?.defendant_adjuster_phone}
                city={data?.defendant_adjuster_city}
                state={data?.defendant_adjuster_state}
                zip_code={data?.defendant_adjuster_zip}
                fax_number={data?.defendant_adjuster_fax}
                ext={data?.defendant_adjuster_extension_field}
                websiteURL={data?.defendant_adjuster_website}
                buttonData={InsuranceButtons}
                pageName="Case Loans"
              />
            </div>
            <Col md={"auto"} className="p-0 d-flex-1">
              <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                <div
                  className="d-flex align-items-center"
                  style={{
                    gap: "5px",
                  }}
                >
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Adjuster First Name"
                    value={data?.defendant_adjuster_first_name || ""}
                    onChange={(e) => onChange("defendant_adjuster_first_name", e.target.value)}
                  />
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Adjuster Last Name"
                    value={data?.defendant_adjuster_last_name || ""}
                    onChange={(e) => onChange("defendant_adjuster_last_name", e.target.value)}
                  />
                </div>
              </div>
              <Row className="align-items-center custom-margin-bottom mx-0">
                <div className="d-flex-1 p-r-5 p-l-0">
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Address 1"
                    value={data?.defendant_adjuster_address1 || ""}
                    onChange={(e) => onChange("defendant_adjuster_address1", e.target.value)}
                  />
                </div>
                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Address 2"
                    value={data?.defendant_adjuster_address2 || ""}
                    onChange={(e) => onChange("defendant_adjuster_address2", e.target.value)}
                  />
                </div>
              </Row>
              <Row className="align-items-center custom-margin-bottom mx-0">
                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="City"
                    className="form-control height-25 p-0 p-l-5 rounded-0"
                    value={data?.defendant_adjuster_city || ""}
                    onChange={(e) => onChange("defendant_adjuster_city", e.target.value)}
                  />
                </div>
                <div className="d-flex-1 p-l-0 position-relative height-25 p-r-5 custom-select-new-provider">
                  <div
                    className="dropdown-button rounded-0 p-0 p-l-5 form-control height-25 d-flex align-items-center"
                    onClick={handleAdjusterStateShowDef}
                  >
                    <span id="selectedOption">
                      {data?.defendant_adjuster_state ? (
                        <div className="d-flex align-items-center">
                          <svg
                            style={{
                              width: "15px",
                              height: "15px",
                              fill: "var(--primary-80)",
                              color: "var(--primary-80)",
                              stroke: "var(--primary-80)",
                            }}
                            className={`icon icon-state-${data?.defendant_adjuster_state}`}
                          >
                            <use xlinkHref={`#icon-state-${data?.defendant_adjuster_state}`} />
                          </svg>
                          {data?.defendant_adjuster_state}
                        </div>
                      ) : (
                        "Select State"
                      )}
                    </span>
                  </div>
                </div>
                <div className="d-flex-1 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="Zip"
                    className="height-25 p-0 p-l-5 rounded-0"
                    value={data?.defendant_adjuster_zip || ""}
                    onChange={(e) => onChange("defendant_adjuster_zip", e.target.value)}
                  />
                </div>
              </Row>
              <Row className="align-items-center custom-margin-bottom mx-0">
                <div className="d-flex-1 p-r-5 p-l-0">
                  <Form.Control
                    type="text"
                    placeholder="(###) ###-####"
                    className="height-25 p-0 p-l-5 rounded-0"
                    value={data?.defendant_adjuster_phone || ""}
                    onChange={(e) => handlePhoneChangeAdjDef(e)}
                  />
                </div>

                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="Extension"
                    className="form-control height-25 p-0 p-l-5 rounded-0"
                    value={data?.defendant_adjuster_extension_field || ""}
                    onChange={(e) => onChange("defendant_adjuster_extension_field", e.target.value)}
                  />
                </div>

                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="(###) ###-#### - fax"
                    className="height-25 p-0 p-l-5 rounded-0"
                    value={data?.defendant_adjuster_fax || ""}
                    onChange={(e) => handleFaxChangeAdjDef(e)}
                  />
                </div>
              </Row>
              <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                <Form.Control
                  type="text"
                  className="height-25 p-0 p-l-5 rounded-0"
                  placeholder="Email"
                  value={data?.defendant_adjuster_email || ""}
                  onChange={(e) => onChange("defendant_adjuster_email", e.target.value)}
                />
              </div>

              <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                <Form.Control
                  type="text"
                  className="height-25 p-0 p-l-5 rounded-0"
                  placeholder="Website"
                  value={data?.defendant_adjuster_website || ""}
                  onChange={(e) => onChange("defendant_adjuster_website", e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <div className="text-end d-flex align-items-center justify-content-end">
            <Button
              variant="primary"
              onClick={() => handleTabChange("Reports")}
              className="height-25 d-flex align-items-center justify-content-center"
            >
              Next
            </Button>
          </div>
        </>
      )}

      {activeTab === "Reports" && (
        <>
          <span
            className="w-100"
            style={{
              background: "var(--primary)",
              color: "white",
              fontWeight: "600",
              display: "flex",
              height: "25px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Reporting Agency Information
          </span>
          <Row className="mx-auto m-t-5 mb-0">
            <Col sm="4" className="ps-0 p-r-5">
              <FormGroup>
                <FormControl
                  type="text"
                  placeholder="Enter Incident Report #"
                  value={data.defendant_report_number || ""}
                  onChange={(e) => onChange("defendant_report_number", e.target.value)}
                  className="form-control height-25 p-l-5 p-0"
                />
              </FormGroup>
            </Col>
            <Col ref={defReportSearchRef} md={6} className="ps-0 p-r-5">
              <Form.Control
                type="text"
                name="search_filter_reporting_agency"
                value={reportSearchInputDef}
                placeholder="Type Reporting Agency to search directory then click an entry"
                className="custom-margin-top custom-margin-bottom height-25 mt-0 p-0 p-l-5 rounded-0"
                onChange={(e) => {
                  setReportSearchInputDef(e.target.value);
                  handleSearchInsurancesDef(e, "reporting");
                }}
              />
              {reportSearchInputDef && (
                <span
                  onClick={() => {
                    setReportSearchInputDef("");
                    handleSearchInsurancesDef({ target: { value: "" } }, "reporting");
                    onChange("defendant_reporting_agency", "");
                    onChange("defendant_report_name", "");
                    onChange("defendant_report_address1", "");
                    onChange("defendant_report_address2", "");
                    onChange("defendant_report_city", "");
                    onChange("defendant_report_state", "");
                    onChange("defendant_report_zip", "");
                    onChange("defendant_report_phone", "");
                    onChange("defendant_report_extension_field", "");
                    onChange("defendant_report_fax", "");
                    onChange("defendant_report_email", "");
                    onChange("defendant_report_website", "");
                  }}
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "5px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "black",
                    lineHeight: 1,
                    userSelect: "none",
                  }}
                >
                  ✕
                </span>
              )}
              {searchReportDef.length > 0 && (
                <AutoCompleteSearch
                  searchedInsurances={searchReportDef}
                  selectedInsurance={(data) => handleSelectedInsuranceTabsDef("reporting", data)}
                  isReport={true}
                />
              )}
            </Col>
            {/* <div
              className="col-md-4 ps-0 p-r-5 custom-select-new-provider"
              style={{ position: "relative" }}
            >
              <div
                className={`dropdown-button form-control p-0 p-l-5 rounded-0 height-25 d-flex align-items-center ${getFieldClass(
                  data.defendant_reporting_agency,
                  false
                )}`}
                onClick={() => setReportingAgencyOpen((prev) => !prev)}
                style={{ cursor: "pointer" }}
              >
                <span>
                  {data.defendant_reporting_agency
                    ? data.defendant_reporting_agency.length > 45
                      ? `${data.defendant_reporting_agency.slice(0, 45)}...`
                      : data.defendant_reporting_agency
                    : "Select Reporting Agency"}
                </span>
              </div>

              {reportingAgencyOpen && (
                <div
                  className="dropdown-menu p-0 mt-0"
                  style={{
                    width: "99%",
                    border: "1px solid #ced4da",
                    maxHeight: "200px",
                    overflowY: "auto",
                    scrollbarWidth: "none",
                  }}
                >
                  <div
                    className="dropdown-option height-25 d-flex align-items-center"
                    style={{ cursor: "pointer", paddingLeft: "5px" }}
                    onClick={() => {
                      onChange("defendant_reporting_agency", "");
                      setReportingAgencyOpen(false);
                    }}
                  >
                    Select Reporting Agency
                  </div>

                  {reportingagencyTypes?.map((type) => {
                    const fullText = type.reporting_agency;
                    const displayText =
                      fullText.length > 45 ? `${fullText.slice(0, 45)}...` : fullText;

                    return (
                      <div
                        key={type.id}
                        title={fullText.length > 45 ? fullText : ""}
                        className="dropdown-option height-25 d-flex align-items-center"
                        style={{
                          cursor: "pointer",
                          paddingLeft: "5px",
                          fontWeight: "600",
                        }}
                        onClick={() => {
                          onChange("defendant_reporting_agency", fullText);
                          setReportingAgencyOpen(false);
                        }}
                      >
                        {displayText}
                      </div>
                    );
                  })}
                </div>
              )}
            </div> */}
          </Row>
          <Row className="mx-0 p-l-5">
            <ContactPanelForEditPopups
              panel_name={"Reporting Agency"}
              className="m-b-5"
              dynamic_label={"Company Name"}
              name={data?.defendant_report_name}
              address1={data?.defendant_report_address1}
              address2={data?.defendant_report_address2}
              email={data?.defendant_report_email}
              phone_number={data?.defendant_report_phone}
              city={data?.defendant_report_city}
              state={data?.defendant_report_state}
              zip_code={data?.defendant_report_zip}
              fax_number={data?.defendant_report_fax}
              ext={data?.defendant_report_extension_field}
              websiteURL={data?.defendant_report_website}
              buttonData={InsuranceButtons}
              pageName="Case Loans"
            />

            <Col md={"auto"} className="p-0 d-flex-1">
              <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                <Form.Control
                  type="text"
                  className="height-25 p-0 p-l-5 rounded-0"
                  placeholder="Name"
                  value={data?.defendant_report_name || ""}
                  onChange={(e) => onChange("defendant_report_name", e.target.value)}
                />
              </div>
              <Row className="align-items-center custom-margin-bottom mx-0">
                <div className="d-flex-1 p-r-5 p-l-0">
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Address 1"
                    value={data?.defendant_report_address1 || ""}
                    onChange={(e) => onChange("defendant_report_address1", e.target.value)}
                  />
                </div>
                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    className="height-25 p-0 p-l-5 rounded-0"
                    placeholder="Address 2"
                    value={data?.defendant_report_address2 || ""}
                    onChange={(e) => onChange("defendant_report_address2", e.target.value)}
                  />
                </div>
              </Row>
              <Row className="align-items-center custom-margin-bottom mx-0">
                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="City"
                    className="form-control height-25 p-0 p-l-5 rounded-0"
                    value={data?.defendant_report_city || ""}
                    onChange={(e) => onChange("defendant_report_city", e.target.value)}
                  />
                </div>
                <div className="d-flex-1 p-l-0 position-relative height-25 p-r-5 custom-select-new-provider">
                  <div
                    className="dropdown-button rounded-0 p-0 p-l-5 form-control height-25 d-flex align-items-center"
                    onClick={handleStateShowRep}
                  >
                    <span id="selectedOption">
                      {data?.defendant_report_state ? (
                        <div className="d-flex align-items-center">
                          <svg
                            style={{
                              width: "15px",
                              height: "15px",
                              fill: "var(--primary-80)",
                              color: "var(--primary-80)",
                              stroke: "var(--primary-80)",
                            }}
                            className={`icon icon-state-${data?.defendant_report_state}`}
                          >
                            <use xlinkHref={`#icon-state-${data?.defendant_report_state}`} />
                          </svg>
                          {data?.defendant_report_state}
                        </div>
                      ) : (
                        "Select State"
                      )}
                    </span>
                  </div>
                </div>
                <div className="d-flex-1 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="Zip"
                    className="height-25 p-0 p-l-5 rounded-0"
                    value={data?.defendant_report_zip || ""}
                    onChange={(e) => onChange("defendant_report_zip", e.target.value)}
                  />
                </div>
              </Row>
              <Row className="align-items-center custom-margin-bottom mx-0">
                <div className="d-flex-1 p-r-5 p-l-0">
                  <Form.Control
                    type="text"
                    placeholder="(###) ###-####"
                    className="height-25 p-0 p-l-5 rounded-0"
                    value={data?.defendant_report_phone || ""}
                    onChange={(e) => handlePhoneChangeRep(e)}
                  />
                </div>

                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="Extension"
                    className="form-control height-25 p-0 p-l-5 rounded-0"
                    value={data?.defendant_report_extension_field || ""}
                    onChange={(e) => onChange("defendant_report_extension_field", e.target.value)}
                  />
                </div>

                <div className="d-flex-1 p-l-0 p-r-5">
                  <Form.Control
                    type="text"
                    placeholder="(###) ###-#### - fax"
                    className="height-25 p-0 p-l-5 rounded-0"
                    value={data?.defendant_report_fax || ""}
                    onChange={(e) => handleFaxChangeRep(e)}
                  />
                </div>
              </Row>
              <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                <Form.Control
                  type="text"
                  className="height-25 p-0 p-l-5 rounded-0"
                  placeholder="Email"
                  value={data?.defendant_report_email || ""}
                  onChange={(e) => onChange("defendant_report_email", e.target.value)}
                />
              </div>

              <div className="d-flex-1 p-l-0 p-r-5 custom-margin-bottom">
                <Form.Control
                  type="text"
                  className="height-25 p-0 p-l-5 rounded-0"
                  placeholder="Website"
                  value={data?.defendant_report_website || ""}
                  onChange={(e) => onChange("defendant_report_website", e.target.value)}
                />
              </div>
            </Col>
          </Row>
          <div className="text-end d-flex align-items-center justify-content-end">
            <Button
              variant="primary"
              onClick={() => handleTabChange("source")}
              className="height-25 d-flex align-items-center justify-content-center"
            >
              Next
            </Button>
          </div>
        </>
      )}

      {/* Source Section */}
      {activeTab === "source" && (
        <>
          {/* <h5 style={{ fontSize: "17px" }}>Source</h5> */}
          <span
            className="w-100"
            style={{
              background: "var(--primary)",
              color: "white",
              fontWeight: "600",
              display: "flex",
              height: "25px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Source Information
          </span>
          <Row className="mx-auto m-b-5 m-t-5">
            <Col sm="12" className="ps-0 pe-0">
              <FormGroup style={{ position: "relative", marginBottom: 0 }}>
                <FormControl
                  type="text"
                  placeholder="Search sources…"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="form-control height-25 p-0 p-l-5"
                />

                {/* Search results — clicking one pre-fills the 3 dropdowns below */}
                {search?.trim() !== "" && (
                  <div
                    style={{
                      position: "absolute",
                      top: "25px",
                      left: 0,
                      right: 0,
                      background: "white",
                      border: "1px solid #ced4da",
                      borderTop: "none",
                      maxHeight: "180px",
                      overflowY: "auto",
                      scrollbarWidth: "none",
                      zIndex: 200,
                      boxShadow: "0 3px 6px rgba(0,0,0,0.08)",
                    }}
                  >
                    {sourceSearchLoading ? (
                      <div style={{ padding: "5px 8px", fontSize: "12px", color: "#999" }}>
                        Searching…
                      </div>
                    ) : searchedSources.length === 0 ? (
                      <div style={{ padding: "5px 8px", fontSize: "12px", color: "#999" }}>
                        No sources found
                      </div>
                    ) : (
                      searchedSources.map((source) => (
                        <div
                          key={source.id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            height: "32px",
                            padding: "0 10px",
                            gap: "8px",
                            cursor: "pointer",
                            background: "transparent",
                            borderBottom: "0.5px solid var(--color-border-tertiary)",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "var(--color-background-secondary)")
                          }
                          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                          onClick={() => {
                            handleTypeChange({ target: { value: source.source_type } });
                            handleCategoryChange({
                              target: { value: source.source_category ?? 0 },
                            });
                            handleSourceNameChange({ target: { value: source.id } });
                            setSearch("");
                          }}
                        >
                          {/* Type + Category breadcrumb */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              flexShrink: 0,
                            }}
                          >
                            {source.source_type_name && (
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "600",
                                  background: "var(--primary-10)",
                                  color: "var(--primary)",
                                  borderRadius: "4px",
                                  padding: "1px 6px",
                                  whiteSpace: "nowrap",
                                  lineHeight: "14px",
                                }}
                              >
                                {source.source_type_name}
                              </span>
                            )}
                            {source.source_category_name && (
                              <>
                                <span
                                  style={{ fontSize: "11px", color: "var(--color-text-tertiary)" }}
                                >
                                  ›
                                </span>
                                <span
                                  style={{
                                    fontSize: "14px",
                                    color: "var(--primary)",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {source.source_category_name}
                                </span>
                              </>
                            )}
                          </div>

                          {/* Divider */}
                          <span
                            style={{
                              width: "0.5px",
                              height: "19px",
                              background: "var(--primary-50)",
                              flexShrink: 0,
                            }}
                          />

                          {/* Source name */}
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "var(--primary)",
                              flex: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {source.name}
                          </span>
                        </div>
                      ))
                    )}
                  </div>
                )}
              </FormGroup>
            </Col>
          </Row>

          <SourceLinking
            ref={sourceLinkingRef} // ← add this
            setShowStatesModalSource={setLinkModal}
            sourceTypes={sourceTypes}
            filteredCategories={filteredCategories}
            filteredCaseSources={filteredCaseSources}
            selectedType={selectedType}
            selectedCategory={selectedCategory}
            selectedSourceName={selectedSourceName}
            handleTypeChange={handleTypeChange}
            handleCategoryChange={handleCategoryChange}
            handleSourceNameChange={handleSourceNameChange}
            disabledCategory={disabledCategory}
            disabledSourceName={disabledSourceName}
            getFieldClass={getFieldClass}
            sourceTypeOpen={sourceTypeOpen}
            setSourceTypeOpen={setSourceTypeOpen}
            sourceCategoryOpen={sourceCategoryOpen}
            setSourceCategoryOpen={setSourceCategoryOpen}
            sourceNameOpen={sourceNameOpen}
            setSourceNameOpen={setSourceNameOpen}
            linkedSources={linkedSources}
            onLinkedChange={setLinkedSources}
            onOpenStateModal={(key) => {
              setPendingSourceStateKey(key);
              setLinkModal(true);
            }}
          />

          {linkModal && (
            <SelectStateModal
              show={linkModal}
              handleClose={() => setLinkModal(false)}
              onChange={(selected) => {
                if (pendingSourceStateKey) {
                  // update that specific linked source's state
                  setLinkedSources((prev) =>
                    prev.map((l) =>
                      l._key === pendingSourceStateKey
                        ? { ...l, metadata: { ...l.metadata, source_state: selected?.StateAbr } }
                        : l
                    )
                  );
                  setPendingSourceStateKey(null);
                } else {
                  // old behavior — main source state field
                  // setHomeStateSource(selected);
                  // onChange("source_state", selected?.StateAbr);
                }
                setLinkModal(false);
              }}
              statesData={state}
            />
          )}
          <div className="text-end d-flex align-items-center justify-content-end">
            <Button
              variant="primary"
              onClick={() => handleTabChange("Notes")}
              className="height-25 d-flex align-items-center justify-content-center"
            >
              Next
            </Button>
          </div>
        </>
      )}

      {activeTab === "Notes" && (
        <>
          <span
            className="w-100"
            style={{
              background: "var(--primary)",
              color: "white",
              fontWeight: "600",
              display: "flex",
              height: "25px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Notes Information
          </span>
          <Col sm="12" className="ps-0 p-r-5 m-t-5">
            <FormGroup>
              <FormControl
                as="textarea"
                className="form-control p-0 p-l-5"
                placeholder="Enter Intake Notes"
                value={data.notes || ""}
                style={{
                  resize: "none",
                  height: "140px",
                }}
                onChange={(e) => onChange("notes", e.target.value)}
              />
            </FormGroup>
          </Col>

          <div className="text-end m-t-5 d-flex align-items-center justify-content-end">
            <Button
              variant="success"
              onClick={handleSave}
              className="height-25 d-flex align-items-center justify-content-center"
              disabled={loadingSave}
              aria-busy={loadingSave}
            >
              {loadingSave ? "Saving..." : "Save"}
            </Button>
          </div>
        </>
      )}

      {showStatesModalIntake && (
        <SelectStateModal
          show={showStatesModalIntake}
          handleClose={() => setShowStatesModalIntake(false)}
          onChange={(selected) => {
            setHomeStateIntake(selected);
            handleCaseState(selected.StateAbr);
          }}
          statesData={state}
        />
      )}

      {insuranceNewCompanyState && (
        <SelectStateModal
          show={insuranceNewCompanyState}
          handleClose={() => setInsuranceNewCompanyState(false)}
          onChange={(selected) => {
            onChange("client_company_state", selected.StateAbr);
          }}
          statesData={state}
        />
      )}

      {adjusterState && (
        <SelectStateModal
          show={adjusterState}
          handleClose={() => setAdjusterState(false)}
          onChange={(selected) => {
            onChange("client_adjuster_state", selected.StateAbr);
          }}
          statesData={state}
        />
      )}

      {reportState && (
        <SelectStateModal
          show={reportState}
          handleClose={() => setReportState(false)}
          onChange={(selected) => {
            onChange("defendant_report_state", selected.StateAbr);
          }}
          statesData={state}
        />
      )}

      {insuranceNewCompanyStateDef && (
        <SelectStateModal
          show={insuranceNewCompanyStateDef}
          handleClose={() => setInsuranceNewCompanyStateDef(false)}
          onChange={(selected) => {
            onChange("defendant_company_state", selected.StateAbr);
          }}
          statesData={state}
        />
      )}

      {adjusterStateDef && (
        <SelectStateModal
          show={adjusterStateDef}
          handleClose={() => setAdjusterStateDef(false)}
          onChange={(selected) => {
            onChange("defendant_adjuster_state", selected.StateAbr);
          }}
          statesData={state}
        />
      )}

      {showStatesModalClient && (
        <SelectStateModal
          show={showStatesModalClient}
          handleClose={() => setShowStatesModalClient(false)}
          onChange={(selected) => {
            setHomeStateClient(selected);
            handleCaseState(selected.StateAbr);
          }}
          statesData={state}
        />
      )}
      {showStatesModalDefendant && (
        <SelectStateModal
          show={showStatesModalDefendant}
          handleClose={() => setShowStatesModalDefendant(false)}
          onChange={(selected) => {
            setHomeStateDefendant(selected);
            onChange("defendant_state", selected.StateAbr);
          }}
          statesData={state}
        />
      )}
      {showStatesModalSource && (
        <SelectStateModal
          show={showStatesModalSource}
          handleClose={() => setShowStatesModalSource(false)}
          onChange={(selected) => {
            setHomeStateSource(selected);
            onChange("source_state", selected.StateAbr);
          }}
          statesData={state}
        />
      )}

      {showStatesModalVenue && (
        <SelectStateModal
          show={showStatesModalVenue}
          handleClose={() => setShowStateModalVenue(false)}
          onChange={(selected) => {
            setHomeStateVenue(selected);
            onChange("venue_state", selected.StateAbr);
            handleCaseState2(selected.StateAbr);
          }}
          statesData={state}
        />
      )}
    </>
  );
};

export default NewClient;
